module.exports = __webpack_public_path__ + "img/hero-photo-3.7e8d6077.jpg";